<ion-app class="app-main flex-container-col" [ngClass]="{ 'hide-footer-class-select': hideFooter$ | async }">
  <header class="header bar" role="banner" [ngClass]="{ 'hide': (classRoasterIsLoading$ | async) }">
    <app-header class="bar-header"></app-header>
    @if (!isAuthenticating) {
      <nav
        class="bar-class-select"
        role="navigation"
        aria-label="Class Selection"
        >
        @if (!!(selectedClassId$ | async)) {
          <app-class-select
            class="class-select"
            (selectionChange)="onClassSelectionChange($event)"
            [selectedClassId]="selectedClassId$ | async"
            [classList]="classList$ | async"
            slot="secondary"
            cssClassName="class-select--app"
          ></app-class-select>
        }
      </nav>
    }
  </header>
  <!-- app level loading indicator -->
  @if (isAuthenticating) {
    <ion-spinner class="status-spinner"></ion-spinner>
  }
  @if (!isAuthenticating) {
    <main class="flex-container-row" role="main">
      @if (!!(selectedClassId$ | async) && !(isUnrecoverableErrorMode$ | async)) {
        <app-navbar class="nav-bar left vertical"></app-navbar>
      }
      <section class="flex-container flex-container-row page-area">
        <ion-content class="content-area flex-item">
          <router-outlet id="contentOutlet"></router-outlet>
        </ion-content>
      </section>
    </main>
  }
  @if (!isAuthenticating && !!(selectedClassId$ | async)) {
    <footer class="bar footer" role="contentinfo">
      <app-navbar class="nav-bar horizontal"></app-navbar>
    </footer>
  }
  @if (!isAuthenticating) {
    <ion-menu
      class="app-menu app-menu__notes"
      menuId="notesMenu"
      side="end"
      type="overlay"
      swipeGesture="false"
      contentId="contentOutlet"
      >
      <notes-menu class="notes-menu"></notes-menu>
    </ion-menu>
  }
  @if (!isAuthenticating) {
    <ion-menu
      (ionDidOpen)="onAllAssessmentsMenuOpen()"
      (ionDidClose)="onAllAssessmentsMenuClose()"
      class="app-menu app-menu__dashboard-menu"
      menuId="allAssessmentsMenu"
      side="end"
      type="overlay"
      swipeGesture="false"
      contentId="contentOutlet"
      >
      <app-dashboard-menu class="dashboard-menu"></app-dashboard-menu>
    </ion-menu>
  }
  @if (!isAuthenticating) {
    <ion-menu
      class="app-menu app-menu__media"
      menuId="mediaMenu"
      side="end"
      type="overlay"
      swipeGesture="false"
      contentId="contentOutlet"
      >
      <media-menu class="media-menu"></media-menu>
    </ion-menu>
  }
  @if (!isAuthenticating) {
    <ion-menu
      class="app-menu app-menu__oral-chart"
      menuId="oralReadingChartMenu"
      side="end"
      type="overlay"
      swipeGesture="false"
      contentId="contentOutlet"
      >
      <app-oral-reading-chart-menu class="oral-chart"></app-oral-reading-chart-menu>
    </ion-menu>
  }
  @if (!isAuthenticating) {
    <ion-menu
      class="app-menu app-menu__observation-report"
      menuId="observationReportFilterMenu"
      side="end"
      type="overlay"
      swipeGesture="false"
      contentId="contentOutlet"
      >
      <app-observation-filter-menu></app-observation-filter-menu>
    </ion-menu>
  }
  @if (!isAuthenticating) {
    <ion-menu
      (ionDidOpen)="onSearchMenuOpen()"
      (ionDidClose)="onSearchMenuClose()"
      class="app-menu app-menu__search"
      menuId="searchMenu"
      side="end"
      type="overlay"
      swipeGesture="false"
      contentId="contentOutlet"
      >
      <app-search-menu class="search-menu"></app-search-menu>
    </ion-menu>
  }
</ion-app>
